import * as Styles from "@universityofmaryland/web-styles-library";
const setShadowStyles = async ({
  shadowRoot,
  styles
}) => {
  const styleElement = document.createElement("style");
  const optimizedCss = await Styles.utilities.transform.css.removeDuplicates(
    styles
  );
  styleElement.textContent = optimizedCss;
  shadowRoot.appendChild(styleElement);
};
export {
  setShadowStyles
};
//# sourceMappingURL=shadow.js.map
